<template>
  <div class="image-uploader" @click="showUploadDialog">
    <input
      type="file"
      v-show="false"
      ref="uploadInput"
      accept=".jpg,.png,.gif,.svg,.jpeg,.webp"
      @change="onUpload"
    />
    <slot>
      <button
        type="button"
        class="default-upload-button"
        :class="{
          busy: busy,
        }"
      >
        <img src="/icons/change.png" class="img-change" />
        {{
          busy
            ? $t("image_uploader.default_busy")
            : $t("image_uploader.default")
        }}
      </button>
    </slot>
  </div>
</template>

<script>
import MediaAPI from "@/api/media";

const FILE_SIZE_LIMIT = 15 * 1024 * 1024;

export default {
  props: {
    image_type: {
      type: String,
      default: 'menu',
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    can_edit: {
      type: Boolean,
      default: false,
    },
    large_logo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    showUploadDialog() {
      this.$refs.uploadInput.click();
    },
    onUpload() {
      let image_file = this.$refs.uploadInput.files[0];

      if (!image_file) return;

      if (image_file.size > FILE_SIZE_LIMIT) {
        alert(this.$t("alerts.file_too_large"));
        return;
      }

      const upload_id = `${Date.now()}`;

      this.$emit("start", upload_id);
      this.busy = true;

      MediaAPI.uploadImage(image_file, this.image_type, this.large_logo)
        .then((response) => {
          if (!response.data.success) {
            this.$emit("fail", response.data.error);
            return;
          }

          //backward compataiblity
          if (!response.data.url) {
            this.$emit("success", response.data.result, upload_id);
          } else {
            this.$emit("success", response.data.url, upload_id);
          }

          this.$refs.uploadInput.value = "";
        })
        .catch((error) => {
          this.$emit("fail", error);
        })
        .finally(() => {
          this.busy = false;
        });
    },
    onDeletePhoto() {
      this.$emit("delete");
    },
  },
};
</script>

<style scoped>
.image-uploader {
  display: contents;
}
</style>